import {Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack} from "@mui/material"
import {useCallback, useEffect, useMemo, useState} from "react" // Imported useMemo
import {useForm, useWatch} from "react-hook-form";
import {AsyncSelect} from "src/components/forms";
import {z} from "src/lib";
import {MensajeFields, SistemaFields} from "../types";
import {useNavigate} from "react-router-dom";
import {zodResolver} from "@hookform/resolvers/zod";
import {EntityWithIdAndDescriptionFields, EntityWithIdFields, QueryStatus} from "src/types";
import {SistemaPrincipalFields} from "src/types/workflow/cache";
import {useSistemas} from "../api";
import {useSistemaPrincipal} from "../../../hooks/useSistemaPrincipal";
import {HttpSystems} from "../../../http/workflow/httpSystems";


const SchemaFields = {
    SistemaPrincipal: MensajeFields.CodigoSistemaPrincipal,
    Sistema: MensajeFields.CodigoSistema
} as const

const schema = z.object({
    [SchemaFields.SistemaPrincipal]: z.number(),
    [SchemaFields.Sistema]: z.number().optional()
})

type Schema = z.infer<typeof schema>

export const NuevoMensaje = () => {
    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const { control, handleSubmit, resetField } = useForm<Schema>({
        resolver: zodResolver(schema),
        mode: 'onChange'
    });

    const sistemaPrincipalId = useWatch({
        control,
        name: SchemaFields.SistemaPrincipal,
    });

    useEffect(() => {
        resetField(SchemaFields.Sistema);
    }, [sistemaPrincipalId, resetField]);

    const getOpcionesSistemaPrincipal = useCallback(async () => {
        const data = await HttpSystems.getSystemPrincipalsWithCreationPermission();
        
        return data.map(opcion => ({
            id: opcion[EntityWithIdFields.Id],
            descripcion: opcion[EntityWithIdAndDescriptionFields.Description],
            icon: <Avatar src={opcion[SistemaPrincipalFields.SrcIcono]} sx={{ height: '20px', width: '20px' }} />
        }));
    }, []);

    const { status, sistemas } = useSistemas(false, sistemaPrincipalId);

    const getOpcionesSistema = useCallback(async () => {
        return sistemas || [];
    }, [sistemas]);

    const navigation = useNavigate();

    const crearNuevo = (data: Schema) => {
        const sistemaId = data[SchemaFields.Sistema];
        const sistema = sistemas?.find(s => s.id === sistemaId);
        const sistemaTipo = sistema?.[SistemaFields.SistemaTipo];

        navigation(`/operacion/nuevo?sistemaPrincipal=${data[SchemaFields.SistemaPrincipal]}&sistemaTipo=${sistemaTipo}&sistema=${sistemaId}`);
    }

    return (
        <>
            <Stack>
                <Button variant='contained' onClick={() => setOpenDialog(true)}>Nuevo</Button>
            </Stack>
            <Dialog open={openDialog} maxWidth='sm' fullWidth>
                <DialogTitle>Nueva operación</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} pt={2}>
                        <Grid item md={6}>
                            <AsyncSelect
                                control={control}
                                name={SchemaFields.SistemaPrincipal}
                                label='País'
                                loadOptions={getOpcionesSistemaPrincipal}
                                fullWidth
                                selectNotNulleable
                                onlyOpenOnArrow
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AsyncSelect
                                key={sistemaPrincipalId}
                                control={control}
                                name={SchemaFields.Sistema}
                                label='Workflow'
                                loadOptions={getOpcionesSistema}
                                disabled={!sistemaPrincipalId || status === QueryStatus.Loading}
                                fullWidth
                                selectNotNulleable
                                onlyOpenOnArrow
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='text' color='primary' onClick={() => setOpenDialog(false)}>
                        Cancelar
                    </Button>
                    <Button variant='contained' color='primary' onClick={handleSubmit(crearNuevo)}>
                        Crear
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}